import { render } from "./dynamic-accordion.vue?vue&type=template&id=886776d8"
import script from "./dynamic-accordion.vue?vue&type=script&lang=js"
export * from "./dynamic-accordion.vue?vue&type=script&lang=js"

import "./dynamic-accordion.vue?vue&type=style&index=0&id=886776d8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__